import angular from 'angular';
import controller from './datagrid.controller';
import template from './datagrid.html';
import fbtemplate from './builder/preview.html';
import DatagridComponent from './datagrid.component';

const datagridConfig = /* @ngInject */ (
	/** @type {any} */ KformComponentsProvider,
	/** @type {any} */ FORM_OPTIONS,
) => {
	KformComponentsProvider.register('datagrid', {
		fbtemplate,
		icon:                   'fa fa-th',
		onEdit: /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.themes = FORM_OPTIONS.themes;
			if (!$scope.component.addAnotherPosition) {
				$scope.component.addAnotherPosition = 'bottom';
			}
			$scope.addAnotherPosition = [
				{
					value: 'top',
					title: 'Top',
				},
				{
					value: 'bottom',
					title: 'Bottom',
				},
				{
					value: 'both',
					title: 'Both',
				},
			];
		},
		views:                  [
			{
				name:     'Display',
				template: 'kform/components/datagrid/display.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/common/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		noDndOverlay:           true,
		confirmRemove:          true,
		title:                  'Data Grid',
		template,
		group:                  'advanced',
		// tableView(data, options) {
		// 	let view = '<table class="table table-striped table-bordered table-child">';
		//
		// 	if (!options.tableChild) {
		// 		view += '<thead><tr>';
		// 		angular.forEach(options.component.components, component => {
		// 			view += `<th>${ component.label || `( ${component.key})`}</th>`;
		// 		});
		// 		view += '</tr></thead>';
		// 	}
		//
		// 	view += '<tbody>';
		// 	angular.forEach(data, row => {
		// 		view += '<tr>';
		// 		kformUtils.eachComponent(options.component.components, component => {
		// 			// If the component has a defined tableView, use that, otherwise try and use the raw data as a string.
		// 			const info = options.componentInfo.components.hasOwnProperty(component.type) ?
		// 				options.componentInfo.components[component.type] :
		// 				{};
		// 			if (info.tableView) {
		// 				// Reset the tableChild value for datagrids, so that components have headers.
		// 				view += `<td>${ info.tableView((row && row[component.key]) || '', {
		// 					component,
		// 					$interpolate: options.$interpolate,
		// 					componentInfo: options.componentInfo,
		// 					tableChild: false,
		// 					util: options.util,
		// 				}) }</td>`;
		// 			}
		// 			else {
		// 				view += '<td>';
		// 				if (component.prefix) {
		// 					view += component.prefix;
		// 				}
		// 				view += (row && row[component.key]) || '';
		// 				if (component.suffix) {
		// 					view += ` ${ component.suffix}`;
		// 				}
		// 				view += '</td>';
		// 			}
		// 		});
		// 		view += '</tr>';
		// 	});
		// 	view += '</tbody></table>';
		// 	return view;
		// },
		controller,
		children:                   false,
		selectable:                 true,
		settings:                   new DatagridComponent(),
	});
};

export default angular.module('app')
	.config(datagridConfig);
